import React, { Component } from "react";
import $ from "jquery";

class TimerD2C extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			sessionTime: '00 : 00',
			timeSpent: '00:00',
			timeBefore: '00:00',
			sessionStarted: false,
			showStartScriptBtn: false,
			redTimer: false,
			showBigClock: false,
			countSecs: 10,
			countInterval: 10,
			currentStationId: "",
			sep: '~@$',
			overStarted: false,
			sessionData: JSON.parse(localStorage.getItem('userData')).sessionData,
			showTimeSpent: false,
			hostJoinedBeforeAutostart: false,
		}
		
		this.xInterval = null;
		this.playerFunctions = window['playerFunctions'];
		window['preClassFeedfmId'] = '';
	}
 
	componentDidMount(){
		
		var mainData = JSON.parse(localStorage.getItem('userData'));
		
		let currDate = new Date(mainData.sessionData.scheduleDate);
		currDate.setMinutes(currDate.getMinutes() + mainData.sessionData.duration);
		this.countdownTimer(currDate);
		this.checkForCountDown(currDate);
	}
	
	componentWillUnmount(){
		clearInterval(this.xInterval);
	}
	
	checkForCountDown=(sessionDate)=>{
		var deadline = 0;
		deadline = new Date(sessionDate).getTime();
		var now = new Date().getTime();
		var userData = JSON.parse(localStorage.getItem('userData'));		
		var sessionData = userData.sessionData;		
		let sessionStartTime = new Date(sessionData.scheduleDate).getTime();
		
		var timeBeforeBegining = sessionStartTime - now;
		timeBeforeBegining = timeBeforeBegining - 1000;
		let seconds = (Math.floor((timeBeforeBegining / 1000) % 60) % 60);
		if ( seconds > 0 && seconds < 11 )
			{
				/*
				this.setState({
					countSecs: seconds,
					countInterval: seconds,
				});
				*/
			}
	}
	
	countdownTimer=(sessionDate)=>{
		if ( !window['isTutorialStarted'] )
			{
				var deadline = 0;
				const userData = JSON.parse(localStorage.getItem('userData'));
				const autoStartBufferInSec = userData.default.hasOwnProperty('d2c_autoStartBufferInSec') ? parseInt(userData.default.d2c_autoStartBufferInSec) : false;
				var sessionData = [];
				if ( userData )
					{
						sessionData = userData.sessionData;
					}
				
				var fullTimeMinutes = sessionData.duration;
				var sessionStations = sessionData.sessionStations;
				var isStopedBefore = false;
				
				var sessionTimes = [];
				for ( let i = 0; i < sessionStations.length; i++ ) 
					{ 
						sessionTimes.push(sessionStations[i].time); 
					}
					
				let tutorialData = JSON.parse(localStorage.getItem('tutorialData'));

				if ( tutorialData ) 
					{
						if ( this.props.state.currentUserData.sessionData.id == tutorialData.sessionId )
							{
								let currentUserData = JSON.parse(localStorage.getItem('userData'));
								let seconds = currentUserData['default']['defaultSessionDuration'] * 60;
								let currDate = new Date();
								currDate.setSeconds(currDate.getSeconds() + seconds);
								deadline = new Date(currDate).getTime();
							}
						else 
							{
								deadline = new Date(sessionDate).getTime();
							}							
					}
				else 
					{
						deadline = new Date(sessionDate).getTime();
					}
					
				var now,
				timeRemaining,
				timeSpent,
				timeBeforeBegining,
				timeOver,
				hours,
				minutes,
				seconds;
				let sessionStartTime = new Date(sessionData.scheduleDate).getTime();
				var mainthis = this;
				this.xInterval = setInterval(function() {

					now = new Date().getTime();
									
					timeRemaining = deadline - now;
					timeSpent = now - sessionStartTime;
					timeBeforeBegining = sessionStartTime - now;
					timeOver = now - deadline;
					
					let timeToStart = sessionStartTime - now;
					timeToStart = timeToStart / 1000;
					
					if ( timeToStart > autoStartBufferInSec )
						{
							mainthis.setState({
								hostJoinedBeforeAutostart: true,
							});
						}
					
					if ( autoStartBufferInSec !== false && autoStartBufferInSec > 0)
						{
							let timeToTrigger = timeToStart - autoStartBufferInSec;
							if ( timeToTrigger < 11 && timeToTrigger > 0 )
								{
									mainthis.props.updateStateFromScript({showBigClock: true, counterSec: parseInt(timeToTrigger)});
								}
							else if ( mainthis.props.showBigClock || mainthis.props.showBigClock == false )
								{
									mainthis.props.updateStateFromScript({showBigClock: false});
								}
							
							if ( timeToStart > 0 && timeToStart <= autoStartBufferInSec && !mainthis.props.state.sessionStarted && mainthis.state.hostJoinedBeforeAutostart )
								{
									console.log('Auto starting Class');
									$('#startClass').trigger('click');
								}
							else if ( timeToStart > 11 && timeToStart <= autoStartBufferInSec && mainthis.props.state.sessionStarted )
								{
									mainthis.props.updateStateFromScript({showBigClock: false});
								}								
							else if ( timeToStart > 1 && timeToStart < 11 && !window['script_is_started'] )
								{
									mainthis.props.updateStateFromScript({showBigClock: true, counterSec: parseInt(timeToStart)});
								}								
							else if ( timeToStart < 1 && timeToStart > -1 && !window['script_is_started'] )
								{
									console.log('Auto starting Activity');
									mainthis.props.updateStateFromScript({showBigClock: false});
									$('#startWork').trigger('click');
								}
						}
					else
						{
							if ( timeToStart > 0 && timeToStart < 11 )
								{
									if ( mainthis.props.showBigClock == false )
										{
											console.log('here');
										}
								}
							else
								{
									mainthis.props.updateStateFromScript({showBigClock: false});
								}
						}
					
					if ( timeBeforeBegining > 1000 )
						{
							let minutesBefore = Math.floor(timeBeforeBegining / 60000);
							let secondsBefore = ("0" + (Math.floor((timeBeforeBegining / 1000) % 60) % 60)).slice(-2);
											
							if ( parseInt(minutesBefore) < 10 )
								{
									minutesBefore = "0" + minutesBefore;
								}
							let totalTimeBefore = minutesBefore + ':' + secondsBefore;
							mainthis.setState({timeBefore: totalTimeBefore});	
							if ( sessionStations.length > 0 ) //&& mainthis.props.state.sessionStarted
								{
									if ( sessionStations[0].time == -1 )
										{
											if ( parseInt(sessionStations[0].stationId) > 0 )
												{
													if ( mainthis.state.currentStationId !== sessionStations[0].stationId ) 
														{ 
															mainthis.playPlayer(sessionStations[0].stationId, sessionStations[0].stationName);
														}
												}		
										}
								}	
						}
					else if ( timeBeforeBegining < 1000 )
						{
							mainthis.setState({timeBefore: '00:00', showTimeSpent: true});
							
							if ( mainthis.state.currentStationId !== "" && !isStopedBefore ) 
								{
									let firstActivityFeedFmId = 0;
									if ( mainthis.state.sessionData && mainthis.state.sessionData.sessionActivity && mainthis.state.sessionData.sessionActivity.length > 0 )
										{
											firstActivityFeedFmId = mainthis.state.sessionData.sessionActivity[0]['fmStationId'];
										}
									
									if ( firstActivityFeedFmId != mainthis.state.currentStationId )
										{
											mainthis.stopPlayer();
										}
									
									isStopedBefore = true;
								}
						}
						
					if ( timeSpent > 0 )
						{
							timeSpent = timeSpent + 1000;
							
							let minutesSpent = Math.floor(timeSpent / 60000);
							let secondsSpent = ("0" + (Math.floor((timeSpent / 1000) % 60) % 60)).slice(-2);
											
							if ( parseInt(minutesSpent) < 10 )
								{
									minutesSpent = "0" + minutesSpent;
								}
								
							let totalTimeSpent = minutesSpent + ':' + secondsSpent;
							mainthis.setState({timeSpent: totalTimeSpent});	
						}
					
					if (timeRemaining < 0) 
						{
							//clearInterval(mainthis.xInterval);
							timeOver = timeOver + 1000;
							let allMinutes = Math.floor(timeOver / 60000);
							seconds = ("0" + (Math.floor((timeOver / 1000) % 60) % 60)).slice(-2);
							if ( parseInt(allMinutes) < 10 )
								{
									allMinutes = "0" + allMinutes;
								}
							let time = allMinutes + ':' + seconds;	
							mainthis.setState({
								overStarted: true,
								sessionTime: time,
							});
						}
					else 
						{
							let allMinutes = Math.floor(timeRemaining / 60000);
							seconds = ("0" + (Math.floor((timeRemaining / 1000) % 60) % 60)).slice(-2);
							if ( parseInt(allMinutes) < 10 )
								{
									allMinutes = "0" + allMinutes;
								}
								
							let time = allMinutes + ':' + seconds;

							window['currentTimeClass'] = time;
							mainthis.setState({sessionTime: time, overStarted: false});

							if ( parseInt(allMinutes) < 1 && parseInt(seconds) < 11 )
								{
									mainthis.setState({
										redTimer: true,	
									});
								}
								
								var totalMinutesLeft = parseInt(allMinutes);
								var currentMinute = fullTimeMinutes - totalMinutesLeft;
								
								if ( sessionTimes.indexOf(currentMinute) > -1 && mainthis.props.state.sessionStarted )
									{
										var index = sessionTimes.indexOf(currentMinute);
										var stationMain = sessionStations[index];
										if ( parseInt(stationMain.stationId) > 0 )
											{
												if ( mainthis.state.currentStationId == stationMain.stationId ) { return false; }
												
												mainthis.playPlayer(stationMain.stationId, stationMain.stationName);
											}
										else
											{
												if ( mainthis.state.currentStationId == "" ) { return false; }
												
												mainthis.stopPlayer();
											}
									}
						}						
				}, 500);	
			}
	}
	
	playPlayer=(id, name)=>{
		this.playerFunctions.stopPlayer();
		setTimeout( function(){
			this.playerFunctions.playPlayer(id, name);
			if ( window['showPlayer'] ){ window['showPlayer'](true); }
		}, 1);
		
		this.setState({currentStationId: id}, 
		()=>{
			window['preClassFeedfmId'] = this.state.currentStationId;
		});
		window['sendMessageToChannel']("feedFm"+this.state.sep+"play"+this.state.sep+id+this.state.sep+name);
		window['currentFmStation'] = id;
		window['currentFmName'] = name;
	}

	stopPlayer=()=>{
		this.playerFunctions.stopPlayer();
		this.setState({currentStationId: ""}, ()=>{
			window['preClassFeedfmId'] = this.state.currentStationId;
		});
		window['sendMessageToChannel']("feedFm"+this.state.sep+"stop");
		if ( window['showPlayer'] ){ window['showPlayer'](false); }
		window['currentFmStation'] = "";
		window['currentFmName'] = "";
	}
	
	render() {
		return (
			<div className={"timerDispl " + (this.props.state.sessionStarted && !this.props.state.showStartScriptBtn ? "timerDiplayWidth" : "")} >
				<div className="timerHolderD2C" className={"timerHolderD2C "} >
					{this.state.timeBefore != '00:00' &&
						<div>
							<div className="displInl">
								<div className="sessionTimerD2C timerToStart2" >{this.state.timeBefore}</div>
								<div className="clockInfo">Time To Start</div>
							</div>
							<div className="sepTimer">|</div>
							<div className="displInl">
								<div className={"sessionTimerD2C timerToStart2 " + ( this.state.redTimer || this.state.overStarted ? "redTimer " : "" ) + ( this.state.sessionTime == 'Class Ended' ? "classEndD2C" : "" ) + ( this.state.sessionTime == 'Class Ended' ? '' : 'noMrgR') } >{this.state.sessionData.duration}:00</div>
								{this.state.overStarted == true ?
									<div className="clockInfo redTimer" id="time_over">Time Over</div>
									:
									<div className="clockInfo">Time Remaining</div>
								}
							</div>
						</div>	
						
					}
					{ this.state.showTimeSpent == true &&
						<div>
							<div className="displInl">
								<div className="sessionTimerD2C timerToStart2" >{this.state.timeSpent}</div>
								<div className="clockInfo">Elapsed Time</div>
							</div>
							<div className="sepTimer">|</div>
							<div className="displInl">
								<div className={"sessionTimerD2C timerToStart2 " + ( this.state.redTimer || this.state.overStarted ? "redTimer " : "" ) + ( this.state.sessionTime == 'Class Ended' ? "classEndD2C" : "" ) + ( this.state.sessionTime == 'Class Ended' ? '' : 'noMrgR') } id="session_time">{this.state.sessionTime}</div>
								{this.state.overStarted == true ?
									<div className="clockInfo redTimer" id="time_over">Time Over</div>
									:
									<div className="clockInfo">Time Remaining</div>
								}
							</div>
						</div>
					}
					{/*
					<div className="sepTimer">|</div>			
					<div className="displInl">
						<div className={"sessionTimerD2C timerToStart2 " + ( this.state.redTimer || this.state.overStarted ? "redTimer " : "" ) + ( this.state.sessionTime == 'Class Ended' ? "classEndD2C" : "" ) + ( this.state.sessionTime == 'Class Ended' ? '' : 'noMrgR') } >{this.state.sessionTime}</div>
						{this.state.overStarted == true ?
							<div className="clockInfo redTimer">Time Over</div>
							:
							<div className="clockInfo">Time Remaining</div>
						}
					</div>
					*/}
				</div>
			</div>
	)}
}
export default TimerD2C;
